const getSupportedCurrencies = {"d":["USD", "EUR", "GBP"]};
export default getSupportedCurrencies;